// extracted by mini-css-extract-plugin
module.exports = {"header":"Gallery_header__3Q2d9","content":"Gallery_content__2mhG-","pagination":"Gallery_pagination__-d3oW","link":"Gallery_link__27YeL"};